export const BANNER_UPLOAD_REQUEST = 'BANNER_UPLOAD_REQUEST'
export const BANNER_UPLOAD_SUCCESS = 'BANNER_UPLOAD_SUCCESS'
export const BANNER_UPLOAD_FALIURE = 'BANNER_UPLOAD_FALIURE'
export const LOGO_UPLOAD_REQUEST = 'LOGO_UPLOAD_REQUEST'
export const LOGO_UPLOAD_SUCCESS = 'LOGO_UPLOAD_SUCCESS'
export const LOGO_UPLOAD_FALIURE = 'LOGO_UPLOAD_FALIURE'
export const GET_UPLOAD_REQUEST = 'GET_UPLOAD_REQUEST'
export const GET_UPLOAD_SUCCESS = 'GET_UPLOAD_SUCCESS'
export const GET_UPLOAD_FALIURE = 'GET_UPLOAD_FALIURE'
